export default __webpack_public_path__ + "images/b100ef53d12e2170911a10893d8e492d-medieval_small.webp";